import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import CalendarEventAppResource from "./CalendarEventAppResource";
import TaskAppResource from "./TaskAppResource";


export const TIMELINE_TYPE = {
    EVENT: 'calendar-event',
    TASK: 'task',
}

class TimelineAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Timeline';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'timelines';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'timeStart',
            'timeEnd',
            'completedDate',
            'description',
            'type',
            'stageTypeUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            deadlineChildrenEvents: CalendarEventAppResource,
            deadlineChildrenTasks: TaskAppResource,
            childrenTasks: TaskAppResource,
            childrenEvents: CalendarEventAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            timeStart: {
                datetime: true,
            },
            timeEnd: {
                datetime: true,
            },
            completedDate: {
                datetime: true,
            },
            description: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            type: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            stageTypeUuid: {
                type: 'string',
            },
        };
    }
}

export default TimelineAppResource;
